module.exports = __webpack_public_path__ + "b56527824f32441654654f0c0b1dc71c.svg";